import { fetchJson } from './client';
import type {
  BookingLinkResponse,
  BookingPortalBookRequest,
  BookingPortalBookResponse,
  BookingPortalClientEventRequest,
  BookingPortalContextResponse,
  BookingPortalSlotsResponse,
  BookingPortalSettings,
  UpdateBookingPortalSettingsRequest,
} from '../../../../shared/types/booking-portal';

function query(params: Record<string, string | null | undefined>): string {
  const search = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value) {
      search.set(key, value);
    }
  }
  const text = search.toString();
  return text ? `?${text}` : '';
}

// Public (no session) — served same-origin through the cal. vhost.
export const bookingPortalApi = {
  context: (shortId: string | null) =>
    fetchJson<BookingPortalContextResponse & { ok: boolean }>(`/api/booking-portal/context${query({ shortId })}`),
  slots: (params: { shortId: string | null; date: string; timezone: string }) =>
    fetchJson<BookingPortalSlotsResponse & { ok: boolean }>(
      `/api/booking-portal/slots${query({ shortId: params.shortId, date: params.date, timezone: params.timezone })}`
    ),
  book: (body: BookingPortalBookRequest) =>
    fetchJson<BookingPortalBookResponse>('/api/booking-portal/book', {
      method: 'POST',
      body: JSON.stringify(body),
    }),
  // Telemetry only: keepalive so navigating away doesn't cancel it, and a
  // failed beacon must never reach the visitor.
  event: (body: BookingPortalClientEventRequest) => {
    void fetch('/api/booking-portal/events', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
      keepalive: true,
    }).catch(() => undefined);
  },
};

// Staff/admin (session-scoped).
export const bookingLinkApi = {
  createForContact: (contactId: string) =>
    fetchJson<BookingLinkResponse & { ok: boolean }>(`/api/contacts/${contactId}/booking-link`, { method: 'POST' }),
  getSettings: () =>
    fetchJson<{ ok: boolean; settings: BookingPortalSettings }>('/api/admin/booking-portal/settings'),
  updateSettings: (body: UpdateBookingPortalSettingsRequest) =>
    fetchJson<{ ok: boolean; settings: BookingPortalSettings }>('/api/admin/booking-portal/settings', {
      method: 'PATCH',
      body: JSON.stringify(body),
    }),
};
